<template>
  <div id="app">
    <localization></localization>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Localization from '@/localization'
import * as firebase from 'firebase/app'
import { notification } from 'ant-design-vue'
export default {
  name: 'app',
  components: { Localization },
  computed: {
    ...mapState(['settings']),
    ...mapState('user', ['authorized']),
    nextRoute() {
      console.log('PATH')
      console.log(this.$route.query.redirect || '/')
      //  this.$route.query.redirect || '/'
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  mounted() {
    console.log(process.env.NODE_ENV)
    this.$cognito.isAuthenticated()
      .then(result => {
        // console.log('Signed in')
        // console.log(result)
        const userEmail = result.idToken.payload.email
        const role = result.idToken.payload['custom:role_name']
        const jwt = result.accessToken.jwtToken
        console.log(role)
        this.$store.dispatch('user/LOAD_CURRENT_COGNITO_ACCOUNT', { payload: { email: userEmail, role: role, jwt: jwt } })
        // console.log(this.$store.state)
        // firebase.firestore().collection('adminSession').doc(userEmail).set({ user: userEmail })
        firebase.firestore().collection('adminSession').doc(userEmail).onSnapshot(document => {
          // console.log(document.data())
          if (document.data() === undefined) {
            // console.log('removed')
            this.$cognito.signout()
            this.$store.dispatch('user/LOGOUT_COGNITO')
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
    // this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT')
    firebase.messaging().onMessage(payload => {
      console.log('Foreground', payload)
      this.$store.commit('ADD_NOTIFICATION', {
        message: payload.data.title,
        description: payload.data.body,
      })
      notification.warning({
        message: payload.data.title,
        description: payload.data.body,
      })
    })
    this.$store.commit('SET_PRIMARY_COLOR', { color: this.settings.primaryColor })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  watch: {
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    authorized(authorized) {
      if (authorized /* && this.currentRoute === '/' */) { /* '/auth/login')  */
        this.$router.replace('/')
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
